module.exports = __webpack_public_path__ + "static/media/20170806_41day_1988AT.ac681817.jpg";